export const table = {
	defaultCategoryName: "Productos",
	exportExcel: "Exportar Excel",
	productCount: {
		singular: "producto",
		plural: "productos",
	},
	loading: {
		categories: "Cargando categorías",
		products: "Cargando Productos",
	},
	dropdown: {
		editCategory: "Editar categoría",
		deleteCategory: "Eliminar categoría",
		categoryButton: "Categoría",
	},
	columns: {
		bars: "Barras",
		barsTooltip: "Haz clic para ver las barras",
		barsLabel: "Barras",
		mountableTooltip: "Haz clic para ver el producto montable",
		productionRuleTooltip: "Haz clic para ver la regla de producción",
		active: "Status",
		mountableDescription: "Montable",
		fiscalCode: "SKU",
		name: "Producto",
		hasProductionRule: "Hoja de datos",
		fiscalData: "Datos fiscales",
		value: "Precio",
		actions: "Acciones",
	},
	fiscalStatus: {
		testedTooltip: "Datos fiscales registrados y validados",
		errorTooltip: "Encontramos errores en los datos fiscales presentados",
		notTestedTooltip: "Datos fiscales registrados. Esperando prueba.",
	},
	variablePrice: "Variable",
	validation: {
		pricePositive: "El precio debe ser un valor positivo",
	},
	priceUpdateSuccess: "El precio de {{productName}} ha sido actualizado exitosamente.",
	notifications: {
		copyImageSuccess: {
			title: "¡Éxito!",
			description: "Hash de imagen copiado al portapapeles",
		},
	},
	emptyState: {
		categoryWithoutProducts: "Categoría sin productos",
		noProductsFound: "No se encontraron productos",
		addProducts: "Agrega productos y vincúlalos a esta categoría.",
		noSearchResults: "No encontramos productos que coincidan con tu búsqueda de",
		clearSearchButton: "Limpiar búsqueda",
		clearFiltersButton: "Limpiar filtros",
		andToAppliedFilters: "y a los filtros aplicados",
		inCategory: 'en la categoría "{{categoryName}}"',
		noProductsMatchingFilters:
			"No encontramos productos que coincidan con los filtros aplicados",
	},
};
